import { EventFeedEvent, InsightFilter } from '@toggle/toggle';

export interface ScenarioInsightWithEvent extends InsightFilter {
  eventId: string;
  read: boolean;
}

export const mergeScenarioInsightsWithEvents = (
  insights: InsightFilter[],
  events: EventFeedEvent[]
): ScenarioInsightWithEvent[] =>
  insights.map(insight => {
    const event = events.find(e => e.source_id === insight.id);
    return {
      ...insight,
      eventId: event?.id ?? '',
      read: event?.read ?? false,
    };
  });
